module.exports = __webpack_public_path__ + "img/introducePageSeven_show_four.4471d934.jpg";